/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : CTA : SIGN UP : STYLES --------------- ++++++++++ */
export default theme => ({
	signupcta: {
		'& .link': {
			color: theme.color.primary.medium.swatch,
			textDecoration: 'underline'
		}
	}
});
